import React, { FC } from "react";
import { Card } from "@yleisradio/areena-types";

import { LargeEndRecommendations } from "../recommendations/LargeEndRecommendations";
import {
  CommonCardProps,
  UiSize
} from "../recommendations/recommendationTypes";
import { SmallEndRecommendations } from "../recommendations/SmallEndRecommendations";

type Props = {
  recommendations: Card[];
  commonCardProps: CommonCardProps;
  showRecommendations: boolean;
  onViewRecommendation: (
    recommendation: Card,
    index: number,
    viewUuid: string
  ) => void;
  onClickRecommendation: (
    recommendation: Card,
    index: number,
    viewUuid: string
  ) => void;
  onClickRecommendationPlay: (
    recommendation: Card,
    index: number,
    viewUuid: string
  ) => void;
};
export const EndRecommendations: FC<Props> = ({
  commonCardProps,
  onClickRecommendation,
  onClickRecommendationPlay,
  onViewRecommendation,
  recommendations,
  showRecommendations
}) => {
  return showRecommendations ? (
    commonCardProps.uiSize === UiSize.Small ? (
      <SmallEndRecommendations
        {...{
          commonCardProps,
          onClickRecommendation,
          onClickRecommendationPlay,
          onViewRecommendation,
          recommendations
        }}
      />
    ) : (
      <LargeEndRecommendations
        {...{
          commonCardProps,
          onClickRecommendation,
          onClickRecommendationPlay,
          onViewRecommendation,
          recommendations
        }}
      />
    )
  ) : null;
};
